export default __webpack_public_path__ + "static/media/OSMOS_RUGGINE_C2_GRIP_60X120_16.55ca4e98.jpg";